import { MetaData, ServicesPage } from '@/components'

export default function NextServicesPage(props) {
  const { meta } = props;
  const title = meta?.title || "Услуги медицинского центра «Sante» в Минске";
  const description = meta?.description || "Полный перечень всех медицинских услуг предоставляемых медицинским центром «Sante» в Минске. Высокое качество обслуживания, низкие цены."

  return (
    <>
      <MetaData title={title} description={description} />
      <ServicesPage {...props} />
    </>
  )
}

NextServicesPage.getInitialProps = async ({ query, api }) => {
  const response = await api.directions({ ...query });

  return response
}
